import React, { useEffect, useState, useCallback } from 'react';
import { useIntl } from 'umi';
import { handlePieData } from '../../constants';
import { getNewsLanguage } from '@/pages/opinion/services/news';
import PieEchart from '../ChannelChart/Charts/PieEchart';
import LineEchart from '../ChannelChart/Charts/LineEchart';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { transRegion } from '@/pages/opinion/utils';
import { getLocale } from 'umi';
import { lineIcon, pieIcon } from '@/pages/opinion/constants/chart';

export default function LanguageChart({ params }: { params: any }) {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [type, setType] = useState('pie');
  const locale = getLocale();

  const { formatMessage } = useIntl();

  useEffect(() => {
    setLoading(true);
    setApiError(false);
    getNewsLanguage({
      ...params,
      types: ['total', 'slice'],
    })
      .then((data: any) => {
        setData(handlePieData(data, 'language'));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  const formatText = useCallback(
    (text) => transRegion(text, locale === 'en-US' ? 3 : 6),
    [locale],
  );

  return (
    <CardCommon
      // hasTitleArrow
      title={formatMessage({ id: 'Language' })}
      defaultOperation="pie"
      operations={[lineIcon, pieIcon]}
      handleOperationsOnClick={({ symbol }) => setType(symbol)}
      loadingHeight={300}
      emptyHeight={300}
      loading={loading}
    >
      <div className="echart-data">
        {type === 'pie' && (
          <PieEchart
            chartData={data.mentions || []}
            total={data.pieMentionTotal || 0}
            formatText={formatText}
          ></PieEchart>
        )}

        {type === 'line' && (
          <LineEchart
            chartData={data.timeline_of_mentions || []}
            dateType={params.date_type}
            startTime={params.start_time}
            endTime={params.end_time}
            formatText={formatText}
          ></LineEchart>
        )}
      </div>
    </CardCommon>
  );
}
